import store from "../../store/store";
import { convertToNotNull } from "../../utils";
export const UserPermissionType = {
  agency: "agency",
  trust: "trust",
  client: "client",
  availability: "availability",
  carer: "carer",
  job: "job",
  rota: "rota",
  timesheet: "timesheet",
  invoice: "invoice",
  wage: "wage",
  user: "user",
  branch: "branch",
  role: "role",
  rate: "rate",
  note: "note",
  grade: "grade",
  speciality: "speciality",
  availability: "availability",
  availabilities: "availabilities",
  holiday: "holiday",
  noteType: "note type",
  documentType: "document type",
  carerType: "carer type",
  template: "template",
  ward: "ward",
  dashboard: "dashboard",
  report: "report",
  nmc: "nmc",
  niscc: "niscc",
};

export const UserActionType = {
  add: "add",
  edit: "edit",
  list: "list",
  remove: "remove",
  detail: "detail",
  import: "import",
  export: "export",
  save: "save",
  cancel: "cancel",
  approve: "approve",
  verify: "verify",
  inquery: "in query",
  moveToWages: "move to wages",
  moveToTimesheet: "move to timesheet",
  finalised: "finalise",
  prepare: "prepare",
  sent: "sent",
  setdefault: "set default",
  setavailability: "set availability",
  showDifferentCount: "show different count",
  showWagesAndInvoices: "show wages and invoices",
  showRota: "show rota",
  showPendingTimesheets: "show pending timesheets",
  showCandidatesLastBooked: "show candidates last booked",
  showCarerBirthdays: "show carer birthdays",
  showTopClientsAndCarers: "show top clients and carers",
};

export function isAllowToAccess(type, action) {
  let roles = store.getState()?.auth?.sessionUser?.roles;
  if (!roles) return false;
  if (!roles[type]) return false;
  if (!roles[type].find((item) => item === action)) return false;
  return true;
}

export function isCheckToList(type) {
  let roles = store.getState()?.auth?.sessionUser?.roles ?? {};
  if (!roles) return false;
  if (!roles[type]) return false;
  return true;
}

export const menuItems = () => {
  let roles = store.getState()?.auth?.sessionUser?.roles;
  if (!roles) return [];
  let menu = [];

  menu.push({
    text: "",
    link: "/",
  });

  roles[UserPermissionType.client] &&
    menu.push({
      text: "Clients",
      link: "/clients",
    });

  roles[UserPermissionType.carer] &&
    menu.push({
      text: "Carers",
      link: "/carers",
    });

  roles[UserPermissionType.job] &&
    menu.push({
      text: "Jobs",
      link: "/jobs",
    });

  roles[UserPermissionType.rota] &&
    menu.push({
      text: "Rotas",
      link: "/rotas",
    });

  roles[UserPermissionType.timesheet] &&
    menu.push({
      text: "Timesheets",
      link: "/timesheets",
    });

  if (roles[UserPermissionType.wage] || roles[UserPermissionType.invoice]) {
    let submenu = [];

    roles[UserPermissionType.wage] &&
      submenu.push({
        text: "Wages",
        link: "/wages",
      });

    roles[UserPermissionType.invoice] &&
      submenu.push({
        text: "Invoices",
        link: "/invoices",
      });

    let item = {
      text: "Invoices",
      subMenu: convertToNotNull(submenu),
    };
    menu.push(item);
  }

  if (roles[UserPermissionType.report]) {
    let submenu = [];

    submenu.push({
      text: "Clients",
      link: "/reports/clients",
    });

    submenu.push({
      text: "Active Clients",
      link: "/reports/active-clients",
    });

    submenu.push({
      text: "Carers",
      link: "/reports/carers",
    });

    submenu.push({
      text: "Active Carers",
      link: "/reports/active-carers",
    });

    submenu.push({
      text: "Timesheet",
      link: "/reports/timesheets",
    });

    let item = {
      text: "Report",
      subMenu: convertToNotNull(submenu),
    };
    menu.push(item);
  }

  if (
    roles[UserPermissionType.user] ||
    roles[UserPermissionType.agency] ||
    roles[UserPermissionType.branch] ||
    roles[UserPermissionType.role] ||
    roles[UserPermissionType.grade] ||
    roles[UserPermissionType.speciality] ||
    roles[UserPermissionType.holiday] ||
    roles[UserPermissionType.noteType] ||
    roles[UserPermissionType.documentType] ||
    roles[UserPermissionType.carerType] ||
    roles[UserPermissionType.template] ||
    roles[UserPermissionType.availabilities]
  ) {
    let submenu = [];

    const permissions = [
      { type: UserPermissionType.agency, text: "Agencies", link: "/agencies" },
      { type: UserPermissionType.branch, text: "Area Managers", link: "/area-managers" },
      { type: UserPermissionType.availability, text: "Availabilities", link: "/availabilities" },
      { type: UserPermissionType.carerType, text: "Carer Types", link: "/carer-types" },
      { type: UserPermissionType.documentType, text: "Document Types", link: "/document-types" },
      { type: UserPermissionType.grade, text: "Grades", link: "/grades" },
      { type: UserPermissionType.holiday, text: "Holidays", link: "/holidays" },
      { type: UserPermissionType.noteType, text: "Note Types", link: "/note-types" },
      { type: UserPermissionType.template, text: "Sage References", link: "/sage-references" },
      { type: UserPermissionType.speciality, text: "Specialities", link: "/specialities" },
      { type: UserPermissionType.template, text: "Templates", link: "/templates" },
      { type: UserPermissionType.trust, text: "Trusts", link: "/trusts" },
      { type: UserPermissionType.user, text: "Users", link: "/users" },
      { type: UserPermissionType.role, text: "User Roles", link: "/roles" },
      { type: UserPermissionType.nmc, text: "NMC", link: "/nmc" },
      { type: UserPermissionType.niscc, text: "NISCC", link: "/niscc" },
    ];

    permissions.forEach((permission) => {
      if (roles[permission.type]) {
        submenu.push({
          text: permission.text,
          link: permission.link,
        });
      }
    });

    let item = {
      text: "Other",
      subMenu: convertToNotNull(submenu),
    };
    menu.push(item);
  }
  return menu;
};
